export default "__VITE_ASSET__B4u5EG2___"